/* ══════════════════════════ the machine outside ══════════════════════════

   studyHub is a web app and talks to nothing. This file is the one exception,
   and the point of it being one file is that the exception stays countable.

   When it runs inside the desktop shell there is a bridge — `window.studyHubDesktop`,
   set up by desktop/preload.js — offering the two things a browser cannot do:
   read Google Calendar over MCP, and keep syllabus attachments on disk. In a
   browser that bridge is simply absent, and every caller is written to expect
   that: `DESK` is null, the features that need it hide themselves, and the
   rest of the app does not notice.

   Mail is not here, and will not be. Reading an inbox to guess at deadlines
   needs a restricted Gmail scope, which a shared web app cannot hold without a
   verification review.

   Everything in this file is a port. If studyHub ever gains a server, this is
   the file that grows a second implementation, and nothing above it changes. */

export const DESK = typeof window !== 'undefined' ? window.studyHubDesktop : null;

/** What the last sync brought back. `events` holds Google's shape, not ours.
 *  @type {{ status: string, account: string, syncedAt: number|null, message: string, events: any[] }} */
export let SYNC = { status: 'never', account: '', syncedAt: null, message: '', events: [] };

export function normalizeSync(raw) {
  const r = raw && typeof raw === 'object' ? raw : {};
  return {
    status: r.status || 'never',
    account: r.account || '',
    syncedAt: typeof r.syncedAt === 'number' ? r.syncedAt : null,
    message: r.message || '',
    events: (Array.isArray(r.events) ? r.events : []).filter((e) => e && e.start),
  };
}

/** Replace what the last sync brought back.
 *
 *  `SYNC` is exported, so only this module may assign to it; callers hand the
 *  raw payload here and get the normalised copy they should render. */
export function setSync(raw) {
  SYNC = normalizeSync(raw);
  return SYNC;
}
